import { LinkedItemFieldDisplay } from "../../../../commonDataObjects/linkedItemsFieldsDisplay";
import * as classNames from "classnames";
import { separateHourFromDateAndFormatToString, getImgAlt, getImgTitle, isAriaHidden } from "widgets/widgetsUtils";
import { secondsToMinutes } from "../../../../siteWidgets/siteWidgetUtils";
import * as apiUrls from "config/apiUrls";
import { getImagesSrc } from "../../../../commonComponents/inline/siteSimpleImage";
import { SignUpForPodcast } from "../../../radioWidgets/articleAudioPodcast/components/signupForPodcast";
import { SimpleLinkRenderer } from "../../../../commonComponents/inline/hyperLink";

interface MultiAudioRowAutoSlotItemProps {
    item: any
    imageWidth: number
    imageHeight: number
    imagesDomain: string
    isMobileWeb?: boolean
    fieldsDisplaySettings: LinkedItemFieldDisplay
}

export class MultiAudioRowAutoSlotItem extends React.Component<MultiAudioRowAutoSlotItemProps, {}> {

    render() {
        const { item, isMobileWeb, fieldsDisplaySettings, imageWidth, imageHeight, imagesDomain } = this.props;
        const { title, subTitle, promotionImageDetails, author, category, publishedLink, articleId } = item;
        const audioArticleData = item.specialData && item.specialData.audioData;
        const categoryText = category && category.textToShow;
        const categoryImage = category && category.categoryIcon ? getImagesSrc(imagesDomain, category.categoryIcon) : null;

        const handleShareClick = async () => {
            if (isMobileWeb) {
                const shareData = { title: title, text: subTitle, url: publishedLink }

                try {
                    // @ts-ignore 
                    await navigator.share(shareData)
                } catch (err) {
                    console.log("error with sharing function", err);
                }
            }
        }

        return (
            <SimpleLinkRenderer href={publishedLink} className={classNames("slotView", { "emptySlot": subTitle.length === 0 && title.length === 0 })}>
                <div className="mediaArea">
                    <img
                        width={"auto"}
                        height={imageHeight}
                        alt={getImgAlt(promotionImageDetails)}
                        title={getImgTitle(promotionImageDetails)}
                        aria-hidden={isAriaHidden(promotionImageDetails)}
                        src={apiUrls.getImageUrl(promotionImageDetails, { w: imageWidth, h: imageHeight })}
                    />

                    <div className="playIcon"></div>
                </div>

                <div className="textArea">
                    {fieldsDisplaySettings.isCategoryVisible &&
                        <div className="podcastDetails">
                            <div className="categoryDetails">
                                <img
                                    width={32}
                                    height={32}
                                    src={categoryImage}
                                    className="categoryImage"
                                    alt={getImgAlt(category.imageDetails)}
                                    title={getImgTitle(category.imageDetails)}
                                    aria-hidden={isAriaHidden(category.imageDetails)}
                                />

                                <div className="category">
                                    {categoryText}
                                </div>
                            </div>

                            {fieldsDisplaySettings.isDateVisible && <div className="date">{separateHourFromDateAndFormatToString(item.dateUpdatedOnSite, { showDate: true, showHour: false, isDateFirst: true, dateTimeSeperator: " | " })}</div>}
                        </div>
                    }

                    {fieldsDisplaySettings.isTitleVisible &&
                        <div className="slotTitle">
                            {title}
                        </div>}

                    {fieldsDisplaySettings.isSubTitleVisible &&
                        <div className="slotSubTitle" >
                            {subTitle}
                        </div>}

                    <div className="moreDetails">
                        <div className="duration">{audioArticleData && audioArticleData.durationSeconds && secondsToMinutes(audioArticleData.durationSeconds, "דק'")}</div>

                        <div className="shareMenu">
                            <SignUpForPodcast className="bepo" categoryId={category.id} followPodcastText={""} />

                            {isMobileWeb && <div className="shareBtn" onClick={handleShareClick}></div>}
                        </div>
                    </div>
                </div>
            </SimpleLinkRenderer>
        )
    }
}